<template>
    <a :id="`session-${session.ID}`"
       :key="session.ID"
       class="list-group-item session-picker-session"
       :class="{
           'active btn-primary': selectedSession && selectedSession.ID === session.ID,
           'session-inactive': session.status === 'Inactive'
       }"
       @click="$emit('select-session', session)">

        <span class="session-index text-muted">{{ sessionNumber }}.</span>
        <span class="fa-solid fa-clock fa-fw"></span>
        {{ timeFilter(session.startTime) }}
        <span v-if="session.endTime !== null">
            <span class="fa-solid fa-circle-arrow-right"></span>
            {{ timeFilter(session.endTime) }}
        </span>

        <SessionSpaceCounts :availability="availability"
                            :spaces-required="spacesRequired" />

        <span v-if="session.name && session.name !== event.name"
              class="session-name">{{ session.name }}</span>
    </a>
</template>

<script>
import SessionAvailability from '@/lib/Sessions/SessionAvailability';
import SessionSpaceCounts from '@/vue/components/Sessions/SessionSpaceCounts';

export default {
    name: 'SessionPickerSession',

    components: {
        SessionSpaceCounts,
    },

    props: {
        event: {
            type: Object,
            required: true,
        },
        session: {
            type: Object,
            required: true,
        },
        sessionNumber: {
            type: Number,
            required: true,
        },
        selectedSession: {
            type: Object,
            default: null,
        },
        spacesRequired: {
            type: Number,
            required: true,
        },
        bookableSpaces: {
            type: Number,
            required: true,
        },
    },

    emits: [
        'select-session',
    ],

    data() {
        return {
            availability: null,
        };
    },

    created() {
        // Convert the props to a standard SessionAvailability object to use with the SessionSpaceCounts component.
        this.availability = new SessionAvailability(
            this.session.ID,
            null,
            this.session.spacesSold,
            this.session.spacesReserved
        ).setSpacesBookable(this.bookableSpaces);
    },
};
</script>

<style lang="less">
@import (reference) "../../../../less/variables";

.session-picker-session {
    padding: 17px 15px;
    // Uses min-height instead of height because there might be a description on the session, which needs to fit.
    min-height: 57px;

    .session-index {
        margin-right: 5px;
    }

    .session-name {
        font-size: 12px;
        font-style: italic;
        display: inline-block;
        padding-left: 16px;
    }

    &.active {
        .session-index {
            color: @white;
        }
    }

    &.session-inactive {
        &,
        &.active {
            border-left-width: 6px !important;
            border-left-color: @brand-warning !important;
        }

        .session-index {
            text-indent: -6px !important;
            display: inline-block;
        }
    }
}
</style>
